<template>
  <v-row class="fill-height">
    <modal-add-calendar-event ref="addCalendarEventDialog"/>
    <v-col>
      <v-sheet height="64">
        <v-toolbar
            flat
        >
          <v-btn
              class="mr-4"
              color="green darken-2"
              @click="$refs.addCalendarEventDialog.open()"
          >
            Dodaj niedostępność
          </v-btn>
          <v-btn
              outlined
              class="mr-4"
              color="grey darken-2"
              @click="setToday"
          >
            Dzisiaj
          </v-btn>
          <v-btn
              fab
              text
              small
              color="grey darken-2"
              @click="prev"
          >
            <v-icon small>
              mdi-chevron-left
            </v-icon>
          </v-btn>
          <v-btn
              fab
              text
              small
              color="grey darken-2"
              @click="next"
          >
            <v-icon small>
              mdi-chevron-right
            </v-icon>
          </v-btn>
          <v-toolbar-title v-if="$refs.calendar">
            {{ $refs.calendar.title }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-menu
              bottom
              right
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  outlined
                  color="grey darken-2"
                  v-bind="attrs"
                  v-on="on"
              >
                <span>{{ typeToLabel[type] }}</span>
                <v-icon right>
                  mdi-menu-down
                </v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="type = 'day'">
                <v-list-item-title>Dzień</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = 'week'">
                <v-list-item-title>Tydzień</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = 'month'">
                <v-list-item-title>Miesiąc</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-toolbar>
      </v-sheet>
      <v-sheet height="600">
        <v-calendar
            ref="calendar"
            v-model="focus"
            color="primary"
            :events="events"
            :event-color="getEventColor"
            :type="type"
            locale="pl"
            @click:event="showEvent"
            @click:more="viewDay"
            @click:date="viewDay"
            @change="updateRange"
        ></v-calendar>
        <v-menu
            v-model="selectedOpen"
            :close-on-content-click="false"
            :activator="selectedElement"
            offset-x
        >
          <v-card
              color="grey lighten-4"
              min-width="350px"
              flat
          >
            <v-toolbar
                :color="selectedEvent.color"
                dark
            >
              <v-btn icon>
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <v-toolbar-title v-html="selectedEvent.name"></v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <div><strong>Oddziały:</strong></div>
              <div v-for="branch in selectedEvent.branches" :key="branch.id">
                {{ branch.name }}
              </div>
              <div><strong>Przedziały czasowe:</strong></div>
              <div v-for="period in selectedEvent.periods" :key="period.id">
                {{ isoDateTime(period.from.timestamp) }} - {{ isoDateTime(period.to.timestamp) }}
              </div>
            </v-card-text>
            <v-card-actions>
              <v-btn
                  text
                  color="secondary"
                  @click="selectedOpen = false"
              >
                Zamknij
              </v-btn>
              <v-btn
                  text
                  color="error"
                  @click="deleteEvent"
              >
                Usuń
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
      </v-sheet>
    </v-col>
  </v-row>
</template>

<script>
import api from '../services/api';
import formatters from '@/mixins/formatters';
import permissions from '@/mixins/permissions';
import ModalAddCalendarEvent from "@/components/ModalAddCalendarEvent.vue";

export default {
  mixins: [
    formatters,
    permissions,
  ],
  components: {ModalAddCalendarEvent},
  data() {
    return {
      start: null,
      end: null,
      events: [],
      loading: false,
      focus: '',
      type: 'month',
      typeToLabel: {
        month: 'Miesiąc',
        week: 'Tydzień',
        day: 'Dzień',
      },
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
    }
  },
  methods: {
    viewDay({date}) {
      this.focus = date
      this.type = 'day'
    },
    getEventColor(event) {
      return event.color
    },
    setToday() {
      this.focus = ''
    },
    prev() {
      this.$refs.calendar.prev()
    },
    next() {
      this.$refs.calendar.next()
    },
    showEvent({nativeEvent, event}) {
      const open = () => {
        this.selectedEvent = event
        this.selectedElement = nativeEvent.target
        requestAnimationFrame(() => requestAnimationFrame(() => this.selectedOpen = true))
      }

      if (this.selectedOpen) {
        this.selectedOpen = false
        requestAnimationFrame(() => requestAnimationFrame(() => open()))
      } else {
        open()
      }

      nativeEvent.stopPropagation()
    },
    updateRange({start, end}) {
      this.load(start, end);
      this.start = start;
      this.end = end;
    },
    deleteEvent() {
      api.delete('/api/calendar/events/' + this.selectedEvent.id)
          .then(() => {
            this.load(this.start, this.end);
            this.selectedOpen = false;
            this.$refs.calendar.checkChange()
          });
    },
    reload() {
      this.load(this.start, this.end);
    },
    load(start, end) {
      if (this.loading) {
        return;
      }
      this.loading = true;

      api.get('/api/calendar/events', {
        params: {
          from: start.date,
          to: end.date,
        }
      })
          .then((response) => {
            this.events = [];
            response.data.forEach((event) => {
              this.events = this.events.concat(this.prepareEvent(event));
            });
          })
          .catch((error) => {
            this.events = [];
            this.$root.$emit('notifyError', {
              html: 'Nie udało się wczytać zdarzeń.',
              error,
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    prepareEvent(event) {
      let events = [];
      event.periods.forEach((period) => {
        events.push({
          id: event.id,
          name: this.eventName(event),
          start: new Date(period.from.timestamp * 1000),
          end: new Date(period.to.timestamp * 1000),
          color: this.stringToColor(event.company.name),
          timed: false,
          branches: event.branches,
          periods: event.periods,
        });
      })

      return events;
    },
    eventName(event) {
      let name = event.company.name;

      if (event.serviceTypes.length > 0) {
        name += ' (';
      }

      event.serviceTypes.forEach((serviceType) => {
        name += serviceType;

        if (event.serviceTypes.indexOf(serviceType) !== event.serviceTypes.length - 1) {
          name += ', ';
        }
      });

      if (event.serviceTypes.length > 0) {
        name += ') ';
      }
      if (event.branches.length > 0) {
        name += ' [';
      }

      event.branches.forEach((branch) => {
        name += branch.name;

        if (event.branches.indexOf(branch) !== event.branches.length - 1) {
          name += ', ';
        }
      });

      if (event.branches.length > 0) {
        name += '] ';
      }

      return name;
    },
    stringToColor(str) {
      let hash = 0;

      for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
      }

      let color = "#";
      for (let i = 0; i < 3; i++) {
        const value = (hash >> (i * 8)) & 0xff;
        color += ("00" + value.toString(16)).slice(-2);
      }

      return color;
    }
  },
  mounted() {
    this.$refs.calendar.checkChange()
  },
}
</script>

<style lang="css">
.v-treeview-node__content {
  cursor: pointer;
}
</style>